<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="24"
    :height="24"
    :viewBox="`0 0 24 24`"
    :aria-labelledby="name"
  >
    <title :id="name" lang="en">{{ name }} icon</title>
    <g v-html="Icons[name]" />
  </svg>
</template>

<script>
import Icons from "./icons.js";

export default {
  name: "BgIcon",
  props: {
    name: {
      type: String
    }
  },
  data() {
    return {
      Icons: Icons
    };
  },
  mounted() {
    if (!Icons[this.name]) {
      throw new Error("no such icon exists");
    }
  }
};
</script>
